"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResponsiveRender = exports.ResponsiveRenderDefs = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactResponsive = require("react-responsive");

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResponsiveRenderDefs = exports.ResponsiveRenderDefs = {
    xs: { min: 0, max: 767 },
    sm: { min: 768, max: 991 },
    md: { min: 992, max: 1199 },
    lg: { min: 1200, max: 100000 }
};

var ResponsiveRender = exports.ResponsiveRender = (_temp = _class = function (_React$Component) {
    _inherits(ResponsiveRender, _React$Component);

    function ResponsiveRender(props) {
        _classCallCheck(this, ResponsiveRender);

        var _this = _possibleConstructorReturn(this, (ResponsiveRender.__proto__ || Object.getPrototypeOf(ResponsiveRender)).call(this, props));

        _this.sizes = ResponsiveRenderDefs;
        return _this;
    }

    _createClass(ResponsiveRender, [{
        key: "render",
        value: function render() {
            var newProps = this.getNewProps();
            return _react2.default.createElement(
                _reactResponsive2.default,
                newProps,
                this.props.children
            );
        }
    }, {
        key: "getNewProps",
        value: function getNewProps() {
            var newProps = Object.assign({}, this.props, {
                maxWidth: this.getMaxWidth(),
                minWidth: this.getMinWidth()
            });

            return this.cleanProps(newProps);
        }
    }, {
        key: "cleanProps",
        value: function cleanProps(oldprops) {
            var deleteableProps = ["xs", "sm", "md", "lg"];
            var props = Object.assign({}, oldprops);
            deleteableProps.map(function (prop) {
                if (props.hasOwnProperty(prop)) delete props[prop];
            });
            return props;
        }
    }, {
        key: "getMaxWidth",
        value: function getMaxWidth() {
            var _this2 = this;

            var max = 0;
            Object.entries(this.sizes).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    name = _ref2[0],
                    size = _ref2[1];

                if (_this2.props[name] && size.max > max) max = size.max;
            });
            return max;
        }
    }, {
        key: "getMinWidth",
        value: function getMinWidth() {
            var _this3 = this;

            var min = 100000;
            Object.entries(this.sizes).map(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    name = _ref4[0],
                    size = _ref4[1];

                if (_this3.props[name] && size.min < min) min = size.min;
            });
            return min;
        }
    }]);

    return ResponsiveRender;
}(_react2.default.Component), _class.defaultProps = {
    xs: false,
    sm: false,
    md: false,
    lg: false
}, _temp);